module.exports = __webpack_public_path__ + "static/media/info.bb0d54a2.svg";